<template>
    <div class="dk-content-wizard">
        <div class="dk-content-wizard__content">
            <div v-if="$scopedSlots.header" class="dk-content-wizard__header !tw-z-[100]">
                <slot name="header" v-bind="bindings"></slot>
            </div>
            <div v-if="$slots.default || $scopedSlots.default" class="dk-content-wizard__body">
                <slot v-bind="bindings"></slot>
            </div>
            <div v-if="$scopedSlots.footer" class="dk-content-wizard__footer">
                <slot name="footer" v-bind="bindings"></slot>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * Multi step content
 *
 * @version 4.0.0
 * @example ./examples/DkContentWizard.md
 */
export default {
    name: 'DkContentWizard',
    data() {
        return {
            currentStepIndex: 0,
            steps: [],
        };
    },
    computed: {
        currentStepPosition() {
            return this.currentStepIndex + 1;
        },
        totalSteps() {
            return this.steps.length;
        },
        stepStatusText() {
            return `${this.currentStepPosition} ${this.$t('dk-content-wizard.of')} ${this.totalSteps}`;
        },
        showPrev() {
            return this.currentStepIndex > 0;
        },
        showNext() {
            return this.currentStepPosition < this.totalSteps;
        },
        showSubmit() {
            return this.currentStepPosition === this.totalSteps;
        },
        bindings() {
            return {
                stepStatusText: this.stepStatusText,
                nextStep: this.nextStep,
                showPrev: this.showPrev,
                previousStep: this.previousStep,
                showNext: this.showNext,
                showSubmit: this.showSubmit,
                currentStepPosition: this.currentStepPosition,
                totalSteps: this.totalSteps,
            };
        },
    },
    mounted() {
        this.setSteps();
        this.handleStepSelection();
    },
    methods: {
        handleStepSelection() {
            if (!this.totalSteps) {
                return;
            }

            const index = this.steps.findIndex((step) => step.active);

            if (index < 0) {
                return (this.steps[this.currentStepIndex].active = true);
            }

            this.currentStepIndex = index;
        },
        previousStep() {
            if (!this.showPrev) {
                return;
            }

            this.currentStepIndex -= 1;
            this.selectStepByIndex(this.currentStepIndex);
        },
        nextStep() {
            if (!this.showNext) {
                return;
            }

            this.currentStepIndex += 1;
            this.selectStepByIndex(this.currentStepIndex);
        },
        selectStepByIndex(index) {
            this.steps.forEach((step) => {
                step.active = false;
            });

            const step = this.steps[index];

            if (step) {
                step.active = true;
            }
        },
        setSteps() {
            this.steps = this.$children.filter((step) => step.$options.name === 'DkContentStep');
        },
    },
};
</script>
